import { render, staticRenderFns } from "./PopoverVariants.vue?vue&type=template&id=03dfff6a"
import script from "./PopoverVariants.vue?vue&type=script&lang=js"
export * from "./PopoverVariants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports